import { SET_ALL_ADMIN, SET_PROFILE, UPDATE_PROFILE } from "../../reducerTypes"

const initialState = {
  profile: {},
  adminList: []
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      }
    case UPDATE_PROFILE:
      return{
        ...state,
        profile: action.payload
      }
    case SET_ALL_ADMIN:
      return{
        ...state,
        adminList: action.payload
      }
    default:
      return state
  }
}

export default authReducer
